import apiClient from "../../utilities/apiService";
const BASE_URL = process.env.REACT_APP_BACKEND_URL;

// Fetch posts from API
export const fetchPostList = async (page, size) => {
    try {
      const response = await apiClient.get(`${BASE_URL}/admin/post/list`, {
        params: { page, size },
      });
      return response.data;  
    } catch (error) {
      throw error;
    }
};

// Fetch recipe details from API
export const fetchRecipe = async (postId) => {
  try {
    const response = await apiClient.get(`${BASE_URL}/posts/summary/${postId}`);
    return response.data;  
  } catch (error) {
    throw error;
  }
};

// delete post from API
export const deletePost = async (postId) => {
  try {
    const response = await apiClient.delete(`${BASE_URL}/admin/post/delete/${postId}`);
    return response.data;
  } catch (error) {
    throw error;
  } 
}

